<template>
  <section class="ranking-card-winner-parts">
    <div class="ranking-card-winner-parts__content">
      <div class="ranking-card-winner-parts__header">
        <h4 class="ranking-card-winner-parts__name">
          {{ rankingCardData.number ? `#${rankingCardData.number} ` : null }}
          {{ rankingCardData.name[$i18n.locale] }}
        </h4>
        <p class="ranking-card-winner-parts__best-data" v-text="rankingCardData.bestData" />
      </div>
      <div v-if="rankingCardData.links.length > 0" class="ranking-card-winner-parts__links">
        <ranking-player-link-parts
          v-for="(link, index) in rankingCardData.links"
          :key="`rankingCardPartsWinnerLink${link}.${index}`"
          :linkData="link"
          :winner="true"
        />
      </div>
    </div>
    <figure class="ranking-card-winner-parts__img">
      <img
        v-if="rankingCardData.img"
        :src="rankingCardData.img"
        :alt="rankingCardData.name[$i18n.locale]"
      />
    </figure>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import { PlayerRankData } from '@/components/RaceListPage/RaceListPane/parts/RankingCardParts.vue'
import RankingPlayerLinkParts from '@/components/RaceListPage/RaceListPane/parts/RankingPlayerLinkParts.vue'

/**
 * レース一覧画面: レース ランキング カードコンポーネント
 */
export default defineComponent({
  name: 'RaceRankingCardParts',
  components: {
    RankingPlayerLinkParts,
  },
  props: {
    rankingCardData: {
      type: Object as PropType<PlayerRankData>,
      required: true,
    },
  },
  setup() {
    return {}
  },
})
</script>

<style lang="scss" scoped>
.ranking-card-winner-parts {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  padding: 10px 15px 0;

  &::after {
    position: absolute;
    left: 15px;
    top: 0;
    content: '';
    display: block;
    width: calc(100% - 30px);
    height: 1px;
    background-color: rgba(255, 255, 255, 0.3);
  }

  &:first-of-type {
    padding-top: 0;

    &::after {
      display: none;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: 54.1%;
    padding: 0 min(#{convertPXtoVW(8), 8px}) 12px 0;
  }

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    width: 100%;
    font-weight: 500;
    text-align: center;
  }

  &__name {
    font-size: min(#{convertPXtoVW(16), 16px});
    line-height: 1.25;
    letter-spacing: 0.04em;
    font-feature-settings: 'palt' on;
  }

  &__best-data {
    font-size: min(#{convertPXtoVW(14), 14px});
    line-height: 1.43;
    letter-spacing: 0.02em;
  }

  &__links {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    width: 100%;
  }

  &__link {
    &--disabled {
      pointer-events: none;
    }
  }

  &__img {
    width: 45.9%;

    img {
      width: 100%;
    }
  }
}
</style>
<style lang="scss">
.ranking-card-winner-parts {
  &__links {
    .atom-icon-router-btn--has-icon {
      display: inline-flex;
      padding: 4px min(#{convertPXtoVW(10), 10px}) 4px min(#{convertPXtoVW(6), 6px});

      img {
        width: min(#{convertPXtoVW(18)}, 18px);
      }
    }
  }
}
</style>
